"use client"

import { useIsAuthenticated } from "@azure/msal-react"
import { Button } from "@/components/ui/button"
import { useMsal } from "@azure/msal-react"
import { loginRequest } from "@/lib/auth-config"
import { useRouter } from "next/navigation"
import { useEffect } from "react"

function isInIframe(): boolean {
  try {
    return window.self !== window.top
  } catch {
    return true
  }
}

export default function HomePage() {
  const isAuthenticated = useIsAuthenticated()
  const { instance } = useMsal()
  const router = useRouter()

  useEffect(() => {
    if (isAuthenticated) {
      router.push("/contacts")
    }
  }, [isAuthenticated, router])

  const handleLogin = async () => {
    if (isInIframe()) {
      try {
        await instance.loginPopup(loginRequest)
      } catch (error) {
        console.error("[v0] Popup login failed:", error)
      }
    } else {
      instance.loginRedirect(loginRequest)
    }
  }

  if (isAuthenticated) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-muted-foreground">Omdirigerer...</div>
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="text-center space-y-6 max-w-md px-6">
        <h1 className="text-4xl font-bold text-foreground">HETO Dialer</h1>
        <p className="text-muted-foreground text-lg">Log ind for at se din kontaktbog</p>
        <Button onClick={handleLogin} size="lg" className="mt-4">
          Log ind med Microsoft
        </Button>
      </div>
    </div>
  )
}
